import React, { useEffect, useState } from 'react';
import { useParams, } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { enqueueSnackbar } from 'notistack';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, TableSortLabel, Grid, Box, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { deleteRentalRateApi, getEscalationDetailsApi, getRentalRateApi } from '../apiService';
import { getQbStatusApi } from '../../quickBooks/apiService';
import RentalRatesList from '../components/RentalRatesList';
import RentalRateCRU from '../components/RentalRateCRU.jsx';
import EscalationModal from '../components/EscalationModal.js';
import InvoiceConfiguration from '../components/InvoiceConfiguration.jsx';
import "../styles/rentalRate.scss"
import { LeasesMenuList, LeasesNav, LeasesBasicDetails } from '../../elements';
import DeletePopUp from '../../../shared_elements/components/DeletePopUp';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { PageLoader, Pagination, STableLoader, hanwahaInstance, jetStreamInstance } from '../../../shared_elements/index.js';
import NoRecordFound from '../../../shared_elements/NoRecordFound';
import { ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import PermissionWrapper from '../../../wrappers/PermissionWrapper.jsx';
import RoleBaseAccess from '../../../hoc/RoleBaseAccess.jsx';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory.jsx';
import { getStorage } from '../../../shared_elements/actionCreators.jsx';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload.js';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout.jsx';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory.jsx';
import { trackActivity } from '../../../utils/mixpanel.js';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import RentalTab from '../components/RentalTabs.js';
import BackToLeaseList from '../../elements/BackToLeaseList.js';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 245px)';

const RentalHd = ({ toggleBulkOps, onRequestSort, sortConfig, item, bulk, isQbEnabled, handleItemClicked }) => {
    const createSortHandler = (property, label) => (event) => {
        onRequestSort(event, property);
        handleItemClicked?.(`Table Sorting: ${label}`);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease_rental_rate", operationType: ['D'] }}>
                        <Checkbox size="small" color="primary" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "name"}
                        direction={sortConfig?.field === "name" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("name", "Rental Name")}>Rental Name</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "rental_type"}
                        direction={sortConfig?.field === "rental_type" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("rental_type", "Rental Type")}>Rental Type</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "account_type"}
                        direction={sortConfig?.field === "account_type" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("account_type", "Account Type")}>Account Type</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "major_assembly"}
                        direction={sortConfig?.field === "major_assembly" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("major_assembly", "Major Assembly")} >Major Assembly</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "interval"}
                        direction={sortConfig?.field === "interval" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("interval", "Interval")} >Interval</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "amount"}
                        direction={sortConfig?.field === "amount" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("amount", "Rate")} >Rate</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "start_date"}
                        direction={sortConfig?.field === "start_date" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("start_date", "Start Date")} >Start Date</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "end_date"}
                        direction={sortConfig?.field === "end_date" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("end_date", "End Date")} >End Date</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "escalation_percentage"}
                        direction={sortConfig?.field === "escalation_percentage" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("escalation_percentage", "Escalation")} >Escalation</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "escalation_interval"}
                        direction={sortConfig?.field === "escalation_interval" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("escalation_interval", "Esc Interval")} > Esc Interval</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "escalation_start_date"}
                        direction={sortConfig?.field === "escalation_start_date" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("escalation_start_date", "Esc. Start Date")} >Esc. Start Date</TableSortLabel>
                </TableCell>
                <TableCell>
                    <TableSortLabel active={sortConfig?.field === "max_cap_amount"}
                        direction={sortConfig?.field === "max_cap_amount" ? sortConfig.direction : "asc"}
                        onClick={createSortHandler("max_cap_amount", "Max Cap Amount")} > Max Cap Amount</TableSortLabel>
                </TableCell>
                {isQbEnabled && <TableCell sx={{ minWidth: "160px" }}>Product & Service</TableCell>}
                {isQbEnabled && <TableCell sx={{ minWidth: "160px" }}>Chart of Account</TableCell>}
                {isQbEnabled && hanwahaInstance && <TableCell sx={{ minWidth: "160px" }}>Class</TableCell>}
                {isQbEnabled && hanwahaInstance && <TableCell sx={{ minWidth: "160px" }}>Sub Class</TableCell>}
            </TableRow>
        </TableHead>
    );
};

const RentalRates = () => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { fileUploadDetails, leaseBasicDetails } = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState({initialLoader:true,escalationLoader:false});
    const [renatlRateInfo, setRenatlRateInfo] = useState({ list: [], pagination: null });
    const [addEditRentalRates, setAddEditRentalRates] = useState({ mode: '', modal: false, data: null })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [deleteRenatlrates, setDeleteRenatlrates] = useState({ modal: false, data: null });
    const [sortConfig, setSortConfig] = useState({ field: '', direction: '' });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [importBackupData, setImportBackupData] = useState([]);
    const [isExport, seIsExport] = useState(false)
    const [escalationView, setEscalationView] = useState({ mode: '', modal: false, data: null });
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [tabIndex, setTabIndex] = useState(0);
    const [slug, setSlug] = useState({})
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [qbStatusLoading, setQbStatusLoading] = useState(jetStreamInstance || hanwahaInstance);
    useEffect(() => {
        const uploadedFileData = getApiResponse("lease_rental_rate", slug);
        setUploadFileProgressData({ uploadedFileData });
        trackActivity('Page Viewed', { page_title: 'Rental Rates' })
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response)) {
                setIsQbEnabled(response.data.data?.is_lessor_enabled);
            }
            setQbStatusLoading(false);
        });
    }, []);
    useEffect(() => {
        if (!leaseBasicDetails?.status) return;
        getRentalRates('initialLoader', { per_page: 50 });
    }, [leaseBasicDetails?.status]);

    const getRentalRates = (loaderType, query = {}) => {
        loaderType === 'initialLoader' ? setSkeletonLoader({initialLoader:true,escalationLoader:false}) : setLoading(true);
        globalGetService(getRentalRateApi(params, query), {}).then(response => {
             setSkeletonLoader({initialLoader:false,escalationLoader:false}) ; setLoading(false);
            if (checkApiStatus(response)) {
                setRenatlRateInfo(response?.data?.data)
            }
        });
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "lease_rental_rate" }))
    }
    const getEscalationDetails = (loaderType, rentalSlug) => {
        loaderType === 'escalationLoader' ? setSkeletonLoader({initialLoader:false, escalationLoader: true }) : setLoading(true);
        globalGetService(getEscalationDetailsApi(params, rentalSlug)).then(response => {
            loaderType === 'escalationLoader' ? setSkeletonLoader({ initialLoader:false,escalationLoader: false }) : setLoading(false);
            if (checkApiStatus(response)) {
                setEscalationView(prev => ({ ...prev, modal: true, data: response?.data?.data }));
            }
        });
    }
    const ondeleteRenatlrates = () => {
        setLoading(true);
        const idsToDelete = bulk?.modal ? (bulk?.ids || []).map(item => item?.id) : [deleteRenatlrates?.data?.id];
        globalDeleteService(deleteRentalRateApi(params), { ids: idsToDelete } )
        .then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                trackActivity('Item Deleted', { page_title: `Delete Rental Rate`, success_msg: response?.data?.message, item_ids: deleteRenatlrates?.data || bulk?.ids, response: response?.data })
                setDeleteRenatlrates({ modal: false, data: null });
                setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                getRentalRates('', { per_page: renatlRateInfo?.pagination?.per_page || 50 });
            }
        });
    };

    const toggleBulkOps = async (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }
    const onRequestSort = (event, property) => {
        const isAsc = sortConfig.field === property && sortConfig.direction === 'asc';
        const newDirection = isAsc ? 'desc' : 'asc';
        setSortConfig({
            field: property,
            direction: newDirection,
        });
        getRentalRates('fetch', {
            page: renatlRateInfo?.pagination?.current_page || 1,
            per_page: renatlRateInfo?.pagination?.per_page || 50,
            sort: newDirection,
            sort_by: property,
        });
    };
    const onDeteAttchments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList,
            data: { ...uploadfileList.data, attachments: uploadfileList?.data?.attachments.filter(item => item?.slug !== deltedslug) }
        });
        if (addEditRentalRates?.modal) {
            setAddEditRentalRates({
                ...addEditRentalRates,
                data: { ...addEditRentalRates.data, attachments: addEditRentalRates.data.attachments.filter(item => item?.slug !== deltedslug) }
            })
        }
        getRentalRates("fetch", { per_page: renatlRateInfo?.pagination?.per_page || 50 });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortConfig?.direction && sortConfig?.field) {
            query = {
                ...query,
                sort: sortConfig?.direction,
                sort_by: sortConfig?.field
            }
        }
        seIsExport(true);
        globalGetService(getRentalRateApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "lease_rental_rate",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getRentalRates("fetch", { per_page: renatlRateInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Rental Rates`, page_type: page_type, })
    }
    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" spacing={1} alignItems='flex-end'>
                            <Grid size={{md:12}}>
                                <RentalTab value={tabIndex} onChange={(e, val) => setTabIndex(val)}/>
                            </Grid>
                            {tabIndex === 0 && <>
                                <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                                    <BackToLeaseList/>
                                </Grid>
                                <Grid item size={{ md: 8, xs: 12 }}>
                                    <ul className='list-inline lease-details-right-items lease-details-btn' style={{ float: 'right', padding:'0px' }}>
                                        <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /></li>
                                        {bulk?.type && bulk?.ids?.length ? <>
                                            <li className='lease-mobile-button'>
                                                <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary">Cancel</Button>
                                            </li>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease_rental_rate", operationType: ['D'] }}>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057" }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                        </> : null}
                                        {renatlRateInfo?.list?.length > 0 ? <li className='lease-mobile-button'><Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'>Export</Button></li> : null}
                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "lease_rental_rate", operationType: ['C'] }}>
                                            <li className='lease-mobile-button'><Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditRentalRates({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Rental Rates</Button></li>
                                        </PermissionWrapper>
                                    </ul>
                                </Grid>
                            </>}
                        </Grid>
                    </Paper>
                        {tabIndex === 1 ? <InvoiceConfiguration />:null}
                        {tabIndex === 0 ?
                    <Paper className='lease-detail-table table-tab-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: renatlRateInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {(skeletonLoader?.initialLoader || qbStatusLoading) ? <STableLoader count={6} rowCount={11} /> : (
                                <Table className="mui-table-format" sx={{ minWidth: `${window.innerWidth + 200}px`, overflow: 'auto' }} stickyHeader>
                                    <RentalHd onRequestSort={onRequestSort} sortConfig={sortConfig} item={renatlRateInfo?.list} bulk={bulk} toggleBulkOps={toggleBulkOps} isQbEnabled={isQbEnabled} handleItemClicked={handleItemClicked} />
                                    <TableBody>
                                        {renatlRateInfo?.list?.length > 0 && (
                                            renatlRateInfo?.list?.map((item, index) => {
                                                const uploadedFileData = getApiResponse("lease_rental_rate", item?.slug);
                                                return (
                                                    <RentalRatesList
                                                        slug={slug?.slug}
                                                        uploadedFileData={uploadedFileData}
                                                        uploadFileProgressData={uploadFileProgressData}
                                                        viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                        key={index}
                                                        item={item}
                                                        bulk={bulk}
                                                        isQbEnabled={isQbEnabled}
                                                        viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                        deleteRenatlrates={deleteRenatlrates}
                                                        toggleBulkOps={toggleBulkOps}
                                                        onEdit={() => setAddEditRentalRates({ modal: true, mode: 'edit', data: item, })}
                                                        onDelete={() => {
                                                            setDeleteRenatlrates({ modal: true, data: item });
                                                            setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                        }}
                                                        onView={() => setAddEditRentalRates({ modal: true, mode: 'view', data: item, })}
                                                        onEscalationView={() => { setEscalationView(prev => ({ ...prev, modal: true, item: item }));getEscalationDetails("escalationLoader",item?.slug)
                                                    }}
                                                    />
                                                );
                                            })
                                        )}
                                    </TableBody>
                                </Table>
                            )}
                        </div>
                        <Paper>
                            {!skeletonLoader?.initialLoader && !renatlRateInfo?.list?.length && <NoRecordFound />}
                            <Pagination
                                pagination={renatlRateInfo?.pagination}
                                onPageChange={(event, newPage) => getRentalRates('', { page: newPage + 1, per_page: renatlRateInfo?.pagination?.per_page, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })}
                                onRowsPerPageChange={(e) => getRentalRates('', { page: 1, per_page: e.target.value, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })}
                            />
                        </Paper>
                    </Paper>:null}
                </div>}
            </Paper>
            {uploadfileList.modal ?
                <ShowAttachments
                    url='lease/delete-attachment'
                    moduleName="Rental Rate"
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditRentalRates?.mode === 'view' || uploadfileList?.mode === 'view'}
                    permissionKey='lease_rental_rate'
                /> : null
            }
            {addEditRentalRates.modal ?
                <RentalRateCRU
                    fileUpload={handleUpload}
                    params={params}
                    renatlRateInfo={renatlRateInfo}
                    modeType={addEditRentalRates?.mode}
                    addEditRentalRates={addEditRentalRates}
                    getResponseBack={() => {getRentalRates('', { per_page: 50 }); setBulk({modal: false, ids: [], type: '',title: ''});}}
                    onToggleModal={() => { setAddEditRentalRates({ modal: false, mode: '', data: null }); }}
                    onImportBackup={(data) => setImportBackupData(data)}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditRentalRates?.data, mode: 'view' })}
                    leaseSlug={leaseSlug}
                /> : null
            }

            {deleteRenatlrates?.modal ?
                <DeletePopUp
                    modal={deleteRenatlrates.modal}
                    title="Delete Rental Rate"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteRenatlrates({ modal: false, data: null })}
                    onDeleteRecords={() => ondeleteRenatlrates()}
                /> : null
            }
            {bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length && bulk.ids.length === (renatlRateInfo?.list?.length || 0) ? 'All Rental Rate' : 'Selected Rental Rate'}`}
                    onDeleteRecords={() => ondeleteRenatlrates()}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
                /> : null
            }
            {revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"lease_rental_rate"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
            {
                escalationView.modal &&
                <EscalationModal
                    moduleName={"escalation_details"}
                    escalationData={escalationView}
                    onToggleModal={() => setEscalationView({ modal: false, mode: '', data: null })}
                    handleItemClicked={handleItemClicked}
                    skeletonLoader={skeletonLoader?.escalationLoader}
                />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>

    )
}
export default RoleBaseAccess(RentalRates, { application: 'lease_revamp', feature: 'lease_rental_rate', operationType: ['R'], leaseNav: true });
